import React from 'react'
import StarIcon from "../../../../styles/img/svg/StarIcon"
import WeekLeftIcon from "../../../../styles/img/svg/WeekLeftIcon"
import EndsTodayIcon from "../../../../styles/img/svg/EndsTodayIcon"
import EventsEndedIcon from "../../../../styles/img/svg/EventsEndedIcon"
import ActiveIcon from "../../../../styles/img/svg/ActiveIcon"
import BuyIcon from "../../../../styles/img/svg/BuyIcon"
import AddToFavourites from "../../../../styles/img/svg/AddToFavourites"
import { UiButtonPrimary } from '../form/UiButton'
import HandIcon from "../../../../styles/img/card-hand-icon.png"
import HeartIcon from "../../../../styles/img/card-heart-icon.png"
import PropTypes from 'prop-types';

export default function UiContentCard(props) {

    return (
        <>
            <div className='sb-content-card'>
                <div className='sb-content-card__inner' onClick={props.readMore}>
                    <div className='sb-content-card__head'>
                        {props.countDownStatus === 'Coming soon' &&
                            <div className='sb-content-card__coming-soon'>
                                <h5>Coming soon</h5>
                            </div>
                        }
                        {props.countDownStatus === 'Active' &&
                            <div className='sb-content-card__active'>
                                <h5>Active</h5>
                            </div>
                        }
                        {props.countDownStatus === 'Closed' &&
                            <div className='sb-content-card__closed'>
                                <h5>Closed</h5>
                            </div>
                        }
                        <img src={props.cardImg} />
                        <div className='sb-content-card__ratings-wr'>
                            <div className='sb-content-card__ratings-content-wr'>
                                {props.timeStatus &&
                                    <div className='sb-content-card__time-status'>
                                        {props.timeStatus == "1 Week Left" &&
                                            <span className='sb-content-card__week-left'><WeekLeftIcon />{props.timeStatus}</span>
                                        }
                                        {props.timeStatus == "Ends Today" &&
                                            <span className='sb-content-card__end-today'><EndsTodayIcon />{props.timeStatus}</span>
                                        }
                                        {props.timeStatus == "Event Ended" &&
                                            <span className='sb-content-card__event-ended'><EventsEndedIcon />{props.timeStatus}</span>
                                        }
                                        {props.timeStatus == "Active" &&
                                            <span className='sb-content-card__active-card'><ActiveIcon />{props.timeStatus}</span>
                                        }
                                    </div>
                                }

                                {props.msgStatus &&
                                    <span className='sb-content-card__msg-badge'>{props.msgStatus}</span>
                                }
                                <div className='sb-content-card__ratings-content'>
                                    {props.rating && <StarIcon />}
                                    <span>{props.rating} {props.reviews && '(' + props.reviews + ')'}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    {props.flashImage ?
                        <div className='sb-content-card__body'>
                            {props.flashImage &&
                                <div className='sb-content-card__banner-wr'>
                                    <img src={props.flashImage} />
                                    <h3>{props.flashText}</h3>
                                </div>
                            }
                        </div> :

                        <>
                            <div className='sb-content-card__body'>

                                <h3>{props.heading}</h3>
                                {props.points &&
                                    <div className='sb-content-card__points-section'>
                                        {props.points &&
                                            <div className='sb-content-card__points'>
                                                <span>{props.points}</span>
                                            </div>
                                        }
                                        {props.savings &&
                                            <div className='sb-content-card__saving-points'>
                                                <span>Saving {props.savings}</span>
                                            </div>
                                        }
                                    </div>
                                }
                                <p>{props.body}
                                    {props.readMore &&
                                        <span onClick={props.readMore}>Read more ...</span>}</p>
                               
                            </div>

                            {props.learnMore &&
                                <div className='sb-content-card__bottom-btn'>
                                    <UiButtonPrimary btnName="Learn more" size="30" onClick={props.learnMore} />
                                </div>
                            }
                            {props.shopAgain &&
                                <div className='sb-content-card__bottom-btn'>
                                    <UiButtonPrimary btnName="Shop Again" size="30" onClick={props.shopAgain} />
                                </div>
                            }
                            {props.visit &&
                                <div className='sb-content-card__bottom-btn'>
                                    <UiButtonPrimary btnName="Visit" size="30" onClick={props.visit} />
                                </div>
                            }

                            {props.MoreButton &&
                                <div className='sb-content-card__bottom-btn'>
                                    <UiButtonPrimary btnName={props.MoreButtonTitle} size="30" onClick={props.MoreButton} />
                                </div>
                            }

                            {props.claimedAmount &&
                                <div className='sb-content-card__bottom-claimed'>
                                    Claimed<span>{props.claimedAmount}</span>times
                                </div>
                            }
                        </>
                    }
                </div>
                {props.footer &&
                    <div className='sb-content-card__footer'>
                        <div className='sb-content-card__footer-left'>
                            <AddToFavourites />
                            <h6>Add to favourites</h6>
                        </div>
                        <div className='sb-content-card__footer-right'>
                            <BuyIcon />
                            <h6>Buy</h6>
                        </div>
                    </div>
                }
            </div>
        </>
    )
}

UiContentCard.propTypes = {
    cardImg: PropTypes.string,
    msgStatus: PropTypes.string,
    rating: PropTypes.string,
    reviews: PropTypes.string,
    flashImage: PropTypes.string,
    flashText: PropTypes.string,
    timeStatus: PropTypes.string,
    heading: PropTypes.string,
    body: PropTypes.string,
    readMore: PropTypes.func,
    points: PropTypes.string,
    learnMore: PropTypes.func,
    bottomIcon: PropTypes.string,
    claimedAmount: PropTypes.string


};